export default {"src":"/_next/static/media/IMG_9288.61b38952.JPG","height":1481,"width":2222};